import ResourceGet from '../../resource/get';

const AssetsGet = () => {

      return(
        <div>
          <ResourceGet resource="assets" name="Assets" />
        </div>
      )

}

export default AssetsGet;